import React, { useEffect, useState } from 'react';
import "./BoxBHYT.scss"

const BoxBHYT = (props) => {
  const { code } = props;
  const [codeBHYT, setCodeBHYT] = useState<any>();
  
  useEffect(()=>{
    renderCodeBox();
  },[code]);

  const renderCodeBox = () => {
    // const chuoi = "HC4338701000405";
    const matches = code.match(/^([A-Z]+)(\d{1})(\d{2})(\d{10})$/);

    if (matches) {
      const [, kyTu, so1, so2, so3] = matches;
      setCodeBHYT([kyTu, so1, so2, so3]);
    } else {
      // console.log("Không tìm thấy kết quả phù hợp.");
    }
  }

  return (
    <div className='box-BHYT'>
      <div className='first-box'>
        <div className='content-1'>{codeBHYT ? codeBHYT[0] : ""}</div>
        <div className='content-2'>{codeBHYT ? codeBHYT[1] : ""}</div>
        <div className='content-3'>{codeBHYT ? codeBHYT[2] : ""}</div>
      </div>
      <div className='second-box'>{codeBHYT ? codeBHYT[3] : ""}</div>
    </div>
  )
}

export default BoxBHYT